import { Component, Renderer2 } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import {
  ICellRendererParams,
} from "ag-grid-community";

@Component({
  selector: "app-require-delivery-cell-renderer",
  templateUrl: "./require-delivery-cell-renderer.component.html",
  styleUrls: ["./require-delivery-cell-renderer.component.css"],
})
export class RequireDeliveryCellRendererComponent
  implements ICellRendererAngularComp
{
  requireDelivery = [
    { value: "YES", viewValue: "YES" },
    { value: "NO", viewValue: "NO" },
  ];

  params: ICellRendererParams;
  deliveryRequired: any;

  constructor(private renderer: Renderer2) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.deliveryRequired = this.params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  getValue(): any {
    return this.deliveryRequired;
  }

  onSelectionChange() {
    this.params.api.stopEditing(); // Stop editing the cell before updating the value
    this.params.setValue(this.deliveryRequired); // Update the cell value within AG Grid
  }

  // Optional: If you need to focus the cell after the editing is complete
  agAfterViewInit(): void {
    const selectElement = document.querySelector("mat-select");
    if (selectElement) {
      this.renderer.selectRootElement(selectElement).focus();
    }
  }
}
